import { OrdemServicoFilters } from '@/types';
import { fetchAllPagesFromApi } from './ordensServicoApiFetcher';
import { processBatchedData } from './ordensServicoBatchProcessor';
import { processPostImportExtraCosts } from './ordensServicoPostImportProcessor';

export const syncWithApi = async (filters?: OrdemServicoFilters, impostoPercentual?: number) => {
  try {
    // ETAPA 1: Buscar e importar dados da API (sem custo extra)
    const apiResult = await fetchAllPagesFromApi(filters);
    
    if (!apiResult.ordensData || apiResult.ordensData.length === 0) {
      return { 
        newOrders: 0, 
        skippedOrders: 0,
        pagesProcessed: apiResult.pagesProcessed || 0,
        extraCostProcessingResult: null
      };
    }
    
    // Processar e converter os dados (sem custo extra)
    const convertedOrdens = await processBatchedData(apiResult.ordensData, impostoPercentual || 0.13);
    
    // ETAPA 2: Processar custo extra pós-importação
    const extraCostResult = await processPostImportExtraCosts(
      filters?.dataInicio,
      filters?.dataFim
    );
    
    return { 
      newOrders: convertedOrdens.length, 
      skippedOrders: apiResult.ordensData.length - convertedOrdens.length,
      pagesProcessed: apiResult.pagesProcessed,
      extraCostProcessingResult: extraCostResult
    };
    
  } catch (error) {
    throw new Error(`Falha na sincronização: ${error.message}`);
  }
};
